// extracted by mini-css-extract-plugin
export default {"FileViewerWrapper":"FileViewer_FileViewerWrapper__WVej8","Skeleton":"FileViewer_Skeleton__CTPhK","FileViewerPreviewContent":"FileViewer_FileViewerPreviewContent__FlCwl"};